import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FormControl, Select } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuItem from '@material-ui/core/MenuItem';

import {
  NO_MODE,
  RULE_SIMPLE_SUM,
  RULE_FIVE_SUM,
  RULE_TEN_SUM,
  RULE_FIVE_AND_TEN_SUM,
  MULTIPLICATION,
  DIVISION,
  SQRT,
  CURT,
  SQUARE,
  CUBE,
  DECIMAL_MODE,
} from '@/modules/Simulators';
import useStyles from '../style';

export const options = [
  {
    value: RULE_SIMPLE_SUM,
    label: 'RULE_SIMPLE_SUM',
  },
  {
    value: RULE_FIVE_SUM,
    label: 'RULE_FIVE_SUM',
  },
  {
    value: RULE_TEN_SUM,
    label: 'RULE_TEN_SUM',
  },
  {
    value: RULE_FIVE_AND_TEN_SUM,
    label: 'RULE_FIVE_AND_TEN_SUM',
  },
  {
    value: NO_MODE,
    label: 'NO_MODE',
  },
  {
    value: MULTIPLICATION,
    label: 'MULTIPLICATION',
  },
  {
    value: DIVISION,
    label: 'DIVISION',
  },
  {
    value: SQRT,
    label: 'SQRT',
  },
  {
    value: CURT,
    label: 'CURT',
  },
  {
    value: SQUARE,
    label: 'SQUARE',
  },
  {
    value: CUBE,
    label: 'CUBE',
  },
  {
    value: DECIMAL_MODE,
    label: 'DECIMAL_MODE',
  },
];

export default function ModeField({ params, changeParams, editOptions }) {
  const classes = useStyles();

  return (
    <Grid item xs={12} classes={{ root: classes.grid }}>
      <FormControl classes={{ root: classes.formControl }}>
        <p className={classes.mainSettingsHeader}>
          <FormattedMessage id="mode" defaultMessage="" />
        </p>
      </FormControl>
      <Select
        MenuProps={{
          style: { zIndex: 2000 },
        }}
        className="settings-input"
        disableUnderline
        inputProps={{ name: 'mode' }}
        value={params.mode}
        onChange={event => changeParams(event.target.value, event.target.name)}
        IconComponent={ExpandMoreIcon}
      >
        {editOptions(options).map(option => (
          <MenuItem key={option.value} value={option.value}>
            <FormattedMessage id={option.label} defaultMessage="" />
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
}

ModeField.propTypes = {
  changeParams: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  editOptions: PropTypes.func,
};

ModeField.defaultProps = {
  editOptions: () => options,
};
